import "$styles/index.css"
import "$styles/prism.css"

// Theme toggle (dark mode)
function initTheme() {
  const stored = localStorage.getItem('theme')
  if (stored === 'dark' || (!stored && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
}

function toggleTheme() {
  const isDark = document.documentElement.classList.contains('dark')
  if (isDark) {
    document.documentElement.classList.remove('dark')
    localStorage.setItem('theme', 'light')
  } else {
    document.documentElement.classList.add('dark')
    localStorage.setItem('theme', 'dark')
  }
}

// Mobile navigation
function initMobileNav() {
  const menuBtn = document.getElementById('mobile-menu-btn')
  const closeBtn = document.getElementById('mobile-menu-close')
  const backdrop = document.getElementById('mobile-menu-backdrop')
  const panel = document.getElementById('mobile-menu-panel')

  if (!menuBtn || !panel) return

  function openMenu() {
    backdrop.classList.remove('hidden')
    panel.classList.remove('hidden')
    requestAnimationFrame(() => {
      backdrop.classList.remove('opacity-0')
      panel.classList.remove('opacity-0', 'scale-95')
    })
  }

  function closeMenu() {
    backdrop.classList.add('opacity-0')
    panel.classList.add('opacity-0', 'scale-95')
    setTimeout(() => {
      backdrop.classList.add('hidden')
      panel.classList.add('hidden')
    }, 150)
  }

  menuBtn.addEventListener('click', openMenu)
  if (closeBtn) closeBtn.addEventListener('click', closeMenu)
  if (backdrop) backdrop.addEventListener('click', closeMenu)

  // Close on nav link click
  panel.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMenu)
  })
}

// Header scroll behavior
function initHeaderScroll() {
  const header = document.getElementById('site-header')
  if (!header) return

  const avatarContainer = document.getElementById('home-avatar-container')
  const isHomePage = !!avatarContainer

  const downDelay = isHomePage ? (avatarContainer?.offsetTop ?? 0) : 0
  const upDelay = 64

  function clamp(number, a, b) {
    return Math.min(Math.max(number, Math.min(a, b)), Math.max(a, b))
  }

  function setProperty(prop, val) {
    document.documentElement.style.setProperty(prop, val)
  }

  function removeProperty(prop) {
    document.documentElement.style.removeProperty(prop)
  }

  let isInitial = true

  function updateStyles() {
    const { top, height } = header.getBoundingClientRect()
    const scrollY = clamp(window.scrollY, 0, document.body.scrollHeight - window.innerHeight)

    if (isInitial) {
      setProperty('--header-position', 'sticky')
    }

    setProperty('--content-offset', `${downDelay}px`)

    if (isInitial || scrollY < downDelay) {
      setProperty('--header-height', `${downDelay + height}px`)
      setProperty('--header-mb', `${-downDelay}px`)
    } else if (top + height < -upDelay) {
      const offset = Math.max(height, scrollY - upDelay)
      setProperty('--header-height', `${offset}px`)
      setProperty('--header-mb', `${height - offset}px`)
    } else if (top === 0) {
      setProperty('--header-height', `${scrollY + height}px`)
      setProperty('--header-mb', `${-scrollY}px`)
    }

    if (top === 0 && scrollY > 0 && scrollY >= downDelay) {
      setProperty('--header-inner-position', 'fixed')
      removeProperty('--header-top')
      removeProperty('--avatar-top')
    } else {
      removeProperty('--header-inner-position')
      setProperty('--header-top', '0px')
      setProperty('--avatar-top', '0px')
    }

    // Avatar scaling (home page only)
    if (isHomePage) {
      const fromScale = 1
      const toScale = 36 / 64
      const fromX = 0
      const toX = 2 / 16

      const scrollYAvatar = downDelay - window.scrollY
      let scale = (scrollYAvatar * (fromScale - toScale)) / downDelay + toScale
      scale = clamp(scale, fromScale, toScale)

      let x = (scrollYAvatar * (fromX - toX)) / downDelay + toX
      x = clamp(x, fromX, toX)

      setProperty('--avatar-image-transform', `translate3d(${x}rem, 0, 0) scale(${scale})`)

      const borderScale = 1 / (toScale / scale)
      const borderX = (-toX + x) * borderScale
      setProperty('--avatar-border-transform', `translate3d(${borderX}rem, 0, 0) scale(${borderScale})`)
      setProperty('--avatar-border-opacity', scale === toScale ? '1' : '0')
    }

    isInitial = false
  }

  updateStyles()
  window.addEventListener('scroll', updateStyles, { passive: true })
  window.addEventListener('resize', updateStyles)
}

// Initialize everything
document.addEventListener('DOMContentLoaded', () => {
  initTheme()
  initMobileNav()
  initHeaderScroll()

  // Theme toggle buttons
  document.querySelectorAll('[data-theme-toggle]').forEach(btn => {
    btn.addEventListener('click', toggleTheme)
  })
})

// Apply theme immediately (before DOMContentLoaded) to prevent flash
initTheme()
